import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { User, Lock, Bell, FileText } from 'lucide-react';

const menuItems = [
  { name: 'User Info', icon: User, path: 'user-info' },
  { name: 'Password & Security', icon: Lock, path: 'password' },
  { name: 'Notifications', icon: Bell, path: 'notifications' },
  { name: 'Privacy Policy', icon: FileText, path: 'privacy-policy' },
];

const SettingsSidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="w-64 bg-white border-r border-gray-200 self-stretch">
      <ul className="pt-6 relative">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname.includes(item.path);

          return (
            <li
              key={item.name}
              onClick={() => navigate(`/settings/${item.path}`)}
              className={`flex items-center gap-3 px-6 py-3 cursor-pointer transition-colors
              ${isActive ? 'text-black font-medium' : 'text-gray-500 hover:text-black'}`}
            >
              <Icon className="w-4 h-4" />
              {item.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SettingsSidebar;
